import React from 'react';
import PropTypes from 'prop-types';
import { Form as AntForm } from 'antd';
import { classNames } from 'utils';
import './Form.scss';

const Form = React.forwardRef(({ className, children, ...rest }, ref) => {
  return (
    <AntForm className={classNames(className, 'Form')} ref={ref} {...rest}>
      {children}
    </AntForm>
  );
});

Form.Item = AntForm.Item;

Form.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Form;
